import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DistrictsVService } from '../../services/V2/padre';
import { handleChange, handleError, trimField } from './Functions';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export function FormController({ keys, model, setModel, hiddenKeys, operatorId }) {
    const [districts, setDistricts] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [showPassword, setShowPassword] = useState<boolean>(false);

    useEffect(() => {
        if(operatorId){
            setLoading(true)
            DistrictsVService.districtsVGetAllAnon(operatorId, true)
                .then(x => {
                    setDistricts(x.sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0))
                    setLoading(false)
                })
                .catch(err => {
                    handleError(err)
                    setLoading(false)
                })
        }
    }, [operatorId])
    
    return (loading ?
        <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
        <>
            {Object.keys(keys).some(x => x.toLowerCase().includes('districtid')) &&
                <FormControl style={{width:"100%", marginTop: "16px", marginBottom: "10px", textAlign: "left"}}>
                    <InputLabel id="districtId-label" htmlFor="districtId">Utility Provider</InputLabel>
                    <Select
                        id="districtId"
                        labelId="districtId-label"
                        name="districtId"
                        value={model === undefined
                            || model === null ? "" : model.districtId}
                        label="Utility Provider"
                        onChange={e => handleChange(e, model, setModel)}
                        fullWidth
                        MenuProps={{ disablePortal: true }}
                        >
                        {districts.map(d => <MenuItem key={d} value={d.id} style={{width: "100%"}}>{d.name}</MenuItem>)}
                    </Select>
                </FormControl>
            }
            {Object.keys(keys).map((p, index) => {
                if (keys[p].type === 'boolean')
                    return null;
                if (hiddenKeys.some(x => p.toLowerCase().includes(x)))
                    return null;
                if(p.toLowerCase().includes('password'))
                    return (
                        <TextField
                            key={index}
                            onChange={e => handleChange(e, model, setModel)}
                            onBlur={e => trimField(e, model, setModel)}
                            margin="normal"
                            id={p}
                            name={p}
                            label={_.startCase(p)}
                            type={showPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={model[p]}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShowPassword(!showPassword)}
                                            onMouseDown={e => e.preventDefault()}
                                            edge="end"
                                            >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />);
                if(keys[p].type === 'number')
                    return (
                        <TextField
                            key={index}
                            onChange={e => handleChange(e, model, setModel)}
                            onBlur={e => trimField(e, model, setModel)}
                            margin="normal"
                            id={p}
                            name={p}
                            label={_.startCase(p)}
                            type="number"
                            value={model[p]}
                            fullWidth
                        />);
                if(p.toLowerCase().includes('districtid'))
                    return null;
                if(p.toLowerCase().includes('fullname'))
                    return (
                        <TextField
                            key={index}
                            onChange={e => handleChange(e, model, setModel)}
                            onBlur={e => trimField(e, model, setModel)}
                            margin="normal"
                            id={p}
                            name={p}
                            label={"Name on Bill"}
                            type="text"
                            value={model[p]}
                            fullWidth
                            autoComplete="name"
                        />);
                return (
                    <TextField
                        key={index}
                        onChange={e => handleChange(e, model, setModel)}
                        onBlur={e => trimField(e, model, setModel)}
                        margin="normal"
                        id={p}
                        name={p}
                        label={_.startCase(p)}
                        type="text"
                        value={model[p]}
                        fullWidth
                        autoComplete={p.toLowerCase().includes('email') ? 'email' : p.toLowerCase().includes('username') ? 'username' : 'off'}
                    />);
            })}
        </>
    );
}